import { AfterViewInit, Component, Inject, Input, LOCALE_ID, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from "@ngx-translate/core";
import { PollService } from "../../../../polls/polls.service";
import { Subject, takeUntil, tap } from "rxjs";
import { RecurringPollResultTrendsLineChartComponent } from "./recurring-poll-result-trends-line-chart/recurring-poll-result-trends-line-chart.component";
import { LineChartSerie, PollResultTimelineItem } from "../poll-result.type";
import { RecurringClosedPollResultTrendsChartComponent } from "./recurring-closed-poll-result-trends-chart/recurring-closed-poll-result-trends-chart.component";
import { PollResultService } from "../poll-result.service";
import { ITeam } from "@teammood/team";
import { UserService } from "@teammood/shared/util/user";
import { Task } from "app/frontend/lib/taskbook-triage/taskbook.types";
import { PollAvailableChoice } from "app/frontend/lib/polls/user-polls/user-polls.type";
import { ClosedRecurrencePollResults, RecurrencePollResults } from "app/frontend/lib/polls/create-poll/create-poll.type";

@Component({
    selector: "recurring-poll-result-trends",
    templateUrl: "./recurring-poll-result-trends.component.html",
    standalone: true,
    imports: [
        MatTabsModule,
        TranslateModule,
        RecurringPollResultTrendsLineChartComponent,
        RecurringClosedPollResultTrendsChartComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [PollService],
})
export class RecurringPollResultTrendsComponent implements AfterViewInit, OnDestroy {
    
    @Input() poll: Task | PollResultTimelineItem;

    protected results: ClosedRecurrencePollResults | RecurrencePollResults;
    protected dates: string[];
    protected locale: string;
    protected teams: ITeam[];
    protected orderedValues: PollAvailableChoice[] = [];
    protected series: LineChartSerie[]; 
    protected nullSeries: number;
    private _destroy$ = new Subject<void>();

    constructor(
        @Inject(LOCALE_ID) locale: string,
        private pollService: PollService,
        private pollResultService: PollResultService,
        private userService: UserService
    ) {
        this.locale = locale;
    }

    ngAfterViewInit(){
        this.userService.get().then(async (user) => {
            if (user) {
                this.teams = [...user.teams];
                this.pollService.getTrends(this.poll.id).pipe(
                    tap(trends => {
                        this.results = trends.allResults;
                        this.dates = this.pollResultService.formatPollTrendResultDates(trends.allResults.dates)
                        if (trends.itemType === 'closedQuestionResultItem') {
                            this.series = this.pollResultService.formatClosedPollTrendResult(this.results.values, this.teams);
                        } else {
                            this.series = this.pollResultService.formatPollTrendResultSeries(this.results.values, this.teams)
                            this.nullSeries = this.series[0].data.filter(value => value === null).length;
                            this.orderedValues = trends.availableChoices.sort((a, b) => b.position - a.position);
                        }
                    }),takeUntil(this._destroy$),
                ).subscribe();
            }
        })
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}